import { useLocation, useNavigate } from "react-router-dom";
import TikTok from "../../pages/TikTok";
import { experimentEnabled, validTikTokView } from "./experiment";
import "./tiktokViewMode.css";

export default function TikTokEntry() {
  const enabled = experimentEnabled();
  const location = useLocation();
  const navigate = useNavigate();
  const view = new URLSearchParams(location.search).get("view");
  const requestedView = validTikTokView(view);
  const chooseView = (view) => {
    const params = new URLSearchParams(location.search);
    params.set("view", view);
    navigate({ pathname: location.pathname, search: `?${params}`, hash: location.hash });
    window.scrollTo(0, 0);
  };
  return <TikTok experiment={enabled ? { requestedView, viewfinderOpen: view === "views", chooseView } : undefined} />;
}
